import { render, staticRenderFns } from "./agendaDoc.vue?vue&type=template&id=356bf7c5&scoped=true&"
import script from "./agendaDoc.vue?vue&type=script&lang=js&"
export * from "./agendaDoc.vue?vue&type=script&lang=js&"
import style0 from "./agendaDoc.vue?vue&type=style&index=0&id=356bf7c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356bf7c5",
  null
  
)

export default component.exports